module.exports = __webpack_public_path__ + "static/media/11-Dresden@3x.58f3c203.jpg";